module.exports = __webpack_public_path__ + "img/backbutton.1436b2ce.svg";